import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiCard from '@mui/material/Card';
import {styled} from '@mui/material/styles';
import {useAuth} from "../context/useAuth";
import { Link } from 'react-router-dom';
import {LinkSecondary} from "../components/link/LinkVariants";
import {TextFieldOutlinedBlueFocus} from "../components/textField/TextFieldVariants";
import {LightHoverButton} from "../components/button/ButtonVariants";

const Card = styled(MuiCard)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '100%',
    padding: theme.spacing(4),
    gap: theme.spacing(2),
    margin: 'auto',
    maxWidth: '450px',
    alignItems: 'start',
}));

export default function LoginPage() {
    const { loginUser } = useAuth();
    const [emailError, setEmailError] = React.useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
    const [passwordError, setPasswordError] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');

    const validateInputs = (email: string, password: string) => {

        let isValid = true;

        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            setEmailError(true);
            setEmailErrorMessage('Bitte geben Sie eine gültige E-Mail Adresse ein.');
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }

        if (!password) {
            setPasswordError(true);
            setPasswordErrorMessage('Bitte geben Sie das Passwort ein.');
            isValid = false;
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
        }

        return isValid;
    };

    const handleSubmit = () => {
        const email = document.getElementById('email') as HTMLInputElement;
        const password = document.getElementById('password') as HTMLInputElement;

        const isValid = validateInputs(email.value, password.value);

        if(isValid){
            if (emailError || passwordError) {
                return;
            }
            if (email && password) {
                loginUser(email.value, password.value);
            }
        }
    };

    return (
        <div className={"centered"}>
            <Card variant="outlined" >
                <Box
                    width="100%"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Typography variant="h1">
                        Anmelden
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        gap: 2,
                    }}
                >
                    <TextFieldOutlinedBlueFocus
                        label="E-Mail Adresse"
                        error={emailError}
                        helperText={emailErrorMessage}
                        id="email"
                        type="email"
                        name="email"
                        placeholder="your@email.com"
                        autoComplete="email"
                        autoFocus
                        required
                        fullWidth
                        variant="outlined"
                        color={emailError ? 'error' : 'primary'}
                    />
                    <TextFieldOutlinedBlueFocus
                        label="Passwort"
                        error={passwordError}
                        helperText={passwordErrorMessage}
                        name="password"
                        placeholder="••••••"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        autoFocus
                        required
                        fullWidth
                        variant="outlined"
                        color={passwordError ? 'error' : 'primary'}
                    />
                    <Typography variant="body2" sx={{ alignSelf: 'flex-end' }}>
                        <Link
                            to="/forgot-password"
                            style={{
                                fontSize: '16px',
                                textDecoration: 'none'
                        }}
                        >
                            Passwort vergessen?
                        </Link>
                    </Typography>
                    <LightHoverButton
                        type="button"
                        fullWidth
                        onClick={handleSubmit}
                    >
                        Anmelden
                    </LightHoverButton>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '0.5rem',
                    }}>
                        <LinkSecondary href="https://red6-es.de/startseite/impressum/" underline="none">
                            Impressum
                        </LinkSecondary>
                        <LinkSecondary href="https://martin-gebuehren.info/datenschutz/" underline="none">
                            Datenschutz
                        </LinkSecondary>
                    </Box>
                </Box>
            </Card>
        </div>
    );
}